import { Col, Row } from "react-bootstrap";

interface ColumnToggleDialogProps {
    columns: {
        name: string;
        visiable: boolean;
    }[];
    setColumns: Function;
    saveColumnState: Function;
}

const ColumnToggleDialog = (props: ColumnToggleDialogProps) => {
    const handleToggleColumn = function (index: number, value: boolean) {
        let columns = props.columns;
        columns[index].visiable = value;

        props.setColumns([...columns]);

        // Wait for the parent state update
        setTimeout(() => {
            props.saveColumnState();
        }, 2000);
    };

    return (
        <div
            className="modal fade"
            id="columnToggle"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Toggle Columns</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">
                        <Row>
                            {props.columns.map((column, index) => (
                                <Col
                                    xs="6"
                                    className="mt-3 d-flex align-center"
                                    key={index}
                                >
                                    <input
                                        checked={column.visiable}
                                        className="form-check-input mx-3"
                                        type="checkbox"
                                        value=""
                                        id="checkDefault"
                                        onChange={(e) =>
                                            handleToggleColumn(
                                                index,
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <label className="form-label">
                                        {column.name}
                                    </label>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ColumnToggleDialog;
